import { createFileRoute } from '@tanstack/react-router';

import { AdminCrosswordPage } from '@/components/admin/crossword-page';
import { adminHead } from '@/lib/seo';
import { adminListCrosswordPuzzlesFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/crossword')({
    component: CrosswordRoute,
    head: () => adminHead('תשחץ יומי', '/admin/crossword'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListCrosswordPuzzlesFn(),
});

function CrosswordRoute() {
    const data = Route.useLoaderData();
    return <AdminCrosswordPage initial={data} />;
}
